import { render, staticRenderFns } from "./vuepdf.vue?vue&type=template&id=c25ad3d0&scoped=true&"
import script from "./vuepdf.vue?vue&type=script&lang=js&"
export * from "./vuepdf.vue?vue&type=script&lang=js&"
import style0 from "./vuepdf.vue?vue&type=style&index=0&id=c25ad3d0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25ad3d0",
  null
  
)

export default component.exports